export default "__VITE_ASSET__Gn_epUo2__"